import { FC, ReactNode } from "react";

import { DevRegionSwitcher } from "./DevRegionSwitcher";

export type JsonObject = { [key: string]: JsonValue };
export type JsonValue =
  | JsonObject
  | JsonValue[]
  | null
  | number
  | string
  | boolean;

/**
 * Display an arbitrary JSON value `object` as preformatted text. Attempts to
 * keep it on one line if it is short, otherwise it is multiline formatted.
 */
export const JsonPre: FC<{ object: JsonValue }> = ({ object }) => {
  let text = JSON.stringify(object);
  if (text.length >= 32) {
    const formattedText = JSON.stringify(object, null, 2);
    if (formattedText.trim().split("\n").length > 3) {
      text = formattedText;
    }
  }
  return <pre>{text}</pre>;
};

export const DevPage: FC<{
  title?: string | ReactNode;
  breadcrumbs?: ReactNode;
  children?: ReactNode;
}> = ({ title, breadcrumbs, children }) => (
  <div className="dev-page">
    <Section additionalClasses={["title-section"]}>
      <div className="dev-title-row">
        <div className="dev-title-row__heading">
          {breadcrumbs}
          {title && <h1>{title}</h1>}
        </div>
        <DevRegionSwitcher />
      </div>
    </Section>
    {children}
  </div>
);

export const Section: FC<{
  children?: ReactNode;
  subtitle?: string | null;
  additionalClasses?: string[];
}> = ({ children, subtitle, additionalClasses = [] }) => (
  <div className={["dev-section"].concat(additionalClasses).join(" ")}>
    {subtitle && <h2>{subtitle}</h2>}
    {children}
  </div>
);

export const Breadcrumbs: FC<{ children?: ReactNode }> = ({ children }) => (
  <nav className="crumbs">
    <ol>{children}</ol>
  </nav>
);

export const Crumb: FC<{ children?: ReactNode }> = ({ children }) => (
  <li className="crumb">{children}</li>
);

export const ErrorMsg: FC<{ msg: string | null }> = ({ msg }) => {
  if (msg) {
    return <span className="error-text">{msg}</span>;
  } else {
    return <></>;
  }
};
